export default [
  {
    "id": "",
    "anrede": "Herr",
    "titel": "",
    "vorname": "Gerhard",
    "nachname": "Heide",
    "staat": "",
    "geburt": "14.03.1968",
    "firma": "Plaut Consulting GmbH",
    "rechtsform": "1234567",
    "gruendungsjahr": "1946",
    "taetigkeit": "Sonst",
    "loginname": "gh1",
    "email": "",
    "tel": "123",
    "fax": "08996280170",
    "mobile": "01637614368",
    "strasse": "Max-von-eyth-Str. 3",
    "plz": "85737",
    "ort": "Ismaning",
    "postfach": "Postfach",
    "pplz": "12345",
    "ktobank": "Volksbank",
    "ktoblz": "20010200",
    "ktonr": "1234567",
    "ktoinhaber": "",
    "sendpolice": "EMAIL",
    "sendmahnung": "NEIN",
    "beruf": "beruf",
    "taetigkeit_txt": "bla",
    "savedate": "17.06.2009 17:21:07",
    "sendergaenz": "POST",
    "sendrechnung": "POST",
    "vmnr": "99999",
    "verifiziert": "0",
    "organisation": "",
    "creationdate": "20.09.2006 00:00:00",
    "delvmnr": "",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "01",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "D-SMYQ-I7MYD-75",
    "dihkname": "Brüninghoff, Anna",
    "dihkrechte": "Gebundener Versicherungsvertreter nach § 34d Abs. 4 GewO",
    "originalwas": "1",
    "kopiewas": "6",
    "kopiepost": "1",
    "provmail": "1",
    "kopieadresse": "test@mail.com",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "TestVerbund",
    "ktobic": "",
    "ktoiban": "DE12500105170648489890",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "",
    "ktoinhaberanrede": ""
  },
  {
    "id": "",
    "anrede": "1",
    "titel": "",
    "vorname": "Robert",
    "nachname": "Brun",
    "staat": "deutsch",
    "geburt": "6.2.1955",
    "firma": "Plaut Deutschland",
    "rechtsform": "privat Person",
    "gruendungsjahr": "1971",
    "taetigkeit": "93HGB",
    "loginname": "jobecher",
    "email": "robert.brun@plaut.de",
    "tel": "089-96280-155",
    "fax": "089-96280-105",
    "mobile": "0177-9224155",
    "strasse": "Max-von-Eyth-Str. 3",
    "plz": "85737",
    "ort": "Ismaning",
    "postfach": "",
    "pplz": "85737",
    "ktobank": "Deutsche Bank",
    "ktoblz": "38070724",
    "ktonr": "411532500",
    "ktoinhaber": "",
    "sendpolice": "EMAIL",
    "sendmahnung": "NEIN",
    "beruf": "",
    "taetigkeit_txt": "",
    "savedate": "27.04.2012 10:40:37",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "99998",
    "verifiziert": "0",
    "organisation": "",
    "creationdate": "14.10.2006 17:41:52",
    "delvmnr": "",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "",
    "maklertyp": "",
    "poolvmnr": "",
    "dihk": "D-9999-99999-99",
    "dihkname": "",
    "dihkrechte": "",
    "kopie": "0",
    "kopiewas": " ",
    "kopiepost": " ",
    "provmail": "0",
    "kopieadresse": "",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "",
    "ktoiban": "",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "",
    "ktoinhaberanrede": ""
  },
  {
    "id": "",
    "anrede": "1",
    "titel": "",
    "vorname": "Juri",
    "nachname": "Münster",
    "staat": "D",
    "geburt": "09.07.1958",
    "firma": "",
    "rechtsform": "",
    "gruendungsjahr": "",
    "taetigkeit": "93HGB",
    "loginname": "JURI",
    "email": "juri.amg@freenet.de",
    "tel": "04144/649-222",
    "fax": "04144/235-576",
    "mobile": "0175/902-70-70",
    "strasse": "Stubbenkamp 26 A",
    "plz": "21709",
    "ort": "Himmelpforten",
    "postfach": "",
    "pplz": "",
    "ktobank": "Spar- und Kreditbank, Hammah, Niederelbe",
    "ktoblz": "20069800",
    "ktonr": "0053374200",
    "ktoinhaber": "",
    "sendpolice": "POST",
    "sendmahnung": "NEIN",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "10.09.2013",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01190",
    "verifiziert": "0",
    "organisation": "",
    "creationdate": "10.09.2013",
    "delvmnr": "2012-09-03-02-10-01",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "",
    "dihkname": "",
    "dihkrechte": "",
    "kopie": "1",
    "kopiewas": "1",
    "kopiepost": "1",
    "provmail": "0",
    "kopieadresse": "",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "GENODEF1HAA",
    "ktoiban": "DE68200698000053374200",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "",
    "ktoinhaberanrede": "1"
  },
  {
    "id": "",
    "anrede": "0",
    "titel": "",
    "vorname": "Brigitte",
    "nachname": "Schröder",
    "staat": "",
    "geburt": "",
    "firma": "Schröder & Schröder GbR",
    "rechtsform": "",
    "gruendungsjahr": "",
    "taetigkeit": "Sonst",
    "loginname": "bschroed",
    "email": "bs@schroederundschroeder.com",
    "tel": "040 / 53299302 + 536",
    "fax": "040 / 53299100 + 536",
    "mobile": "",
    "strasse": "Flughafenstr. 52  ( Haus C )",
    "plz": "22335",
    "ort": "Hamburg",
    "postfach": "",
    "pplz": "",
    "ktobank": "HSH Nordbank Hamburg, Kiel, Kiel",
    "ktoblz": "21050000",
    "ktonr": "1000262786",
    "ktoinhaber": "",
    "sendpolice": "EMAIL",
    "sendmahnung": "EMAIL",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "10.09.2013",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01191",
    "verifiziert": "0",
    "organisation": "",
    "creationdate": "10.09.2013",
    "delvmnr": "2012-09-03-02-10-01",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "",
    "dihkname": "",
    "dihkrechte": "",
    "kopie": "1",
    "kopiewas": "3",
    "kopiepost": "1",
    "provmail": "0",
    "kopieadresse": "",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "HSHNDEHHXXX",
    "ktoiban": "DE11210500001000262786",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "",
    "ktoinhaberanrede": "0"
  },
  {
    "id": "",
    "anrede": "1",
    "titel": "",
    "vorname": "Thomas",
    "nachname": "Mehmel-Kösters",
    "staat": "d",
    "geburt": "",
    "firma": "VPM Consulting",
    "rechtsform": "GmbH",
    "gruendungsjahr": "1987",
    "taetigkeit": "93HGB",
    "loginname": "vpmgmbh",
    "email": "tmk@vpm-consulting.de",
    "tel": "069 593850",
    "fax": "",
    "mobile": "",
    "strasse": "Hebelstrasse 11",
    "plz": "60318",
    "ort": "Frankfurt",
    "postfach": "",
    "pplz": "",
    "ktobank": "Frankfurter Sparkasse, Frankfurt am Main",
    "ktoblz": "50050201",
    "ktonr": "0200330330",
    "ktoinhaber": "",
    "sendpolice": "EMAIL",
    "sendmahnung": "EMAIL",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "10.09.2013",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01196",
    "verifiziert": "0",
    "organisation": "",
    "creationdate": "10.09.2013",
    "delvmnr": "2012-09-03-02-10-01",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "",
    "dihkname": "",
    "dihkrechte": "",
    "kopie": "1",
    "kopiewas": "3",
    "kopiepost": "1",
    "provmail": "0",
    "kopieadresse": "",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "HELADEF1822",
    "ktoiban": "DE61500502010200330330",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "",
    "ktoinhaberanrede": "1"
  },
  {
    "id": "",
    "anrede": "1",
    "titel": "",
    "vorname": "Rainer",
    "nachname": "Hassenpflug",
    "staat": "Deutsch",
    "geburt": "30.10.1960",
    "firma": "Finanzberatung Gerhard Hassenpflug",
    "rechtsform": "Einzel",
    "gruendungsjahr": "1974",
    "taetigkeit": "Sonst",
    "loginname": "zzggtt",
    "email": "zzggtt@web.de",
    "tel": "02354-709751",
    "fax": "02354-709752",
    "mobile": "",
    "strasse": "Drosselweg 6",
    "plz": "58540",
    "ort": "Meinerzhagen",
    "postfach": "1222",
    "pplz": "58528",
    "ktobank": "Volksbank Meinerzhagen -alt-, Meinerzhagen",
    "ktoblz": "45861617",
    "ktonr": "1144360809",
    "ktoinhaber": "",
    "sendpolice": "EMAIL",
    "sendmahnung": "EMAIL",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "10.09.2013",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01195",
    "verifiziert": "0",
    "organisation": "",
    "creationdate": "10.09.2013",
    "delvmnr": "2012-09-03-02-10-01",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "",
    "dihkname": "",
    "dihkrechte": "",
    "kopie": "1",
    "kopiewas": "3",
    "kopiepost": "1",
    "provmail": "0",
    "kopieadresse": "",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "GENODEM1MOM",
    "ktoiban": "DE43458616171144360809",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "",
    "ktoinhaberanrede": "1"
  },
  {
    "id": "",
    "anrede": "1",
    "titel": "",
    "vorname": "Sieghart",
    "nachname": "Michelmann",
    "staat": "D",
    "geburt": "1.1.1990",
    "firma": "Finanzdienst Michelmann",
    "rechtsform": "AG",
    "gruendungsjahr": "1981",
    "taetigkeit": "93HGB",
    "loginname": "L01006",
    "email": "gerhard.heide@web.de",
    "tel": "0 72 43/6 90 11",
    "fax": "0 72 43/60 63 15",
    "mobile": "",
    "strasse": "Postfach 1224",
    "plz": "76334",
    "ort": "Waldbronn",
    "postfach": "1224",
    "pplz": "76334",
    "ktobank": "PSD Bank Hessen-Thüringen, Eschborn, Taunus",
    "ktoblz": "",
    "ktonr": "",
    "ktoinhaber": "",
    "sendpolice": "POST",
    "sendmahnung": "NEIN",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "16.11.2017 15:49:45",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01006",
    "verifiziert": "1",
    "organisation": "",
    "creationdate": "04.08.2014",
    "delvmnr": "2012-09-03-02-10-01",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "D-VRRY-T3MJA-91",
    "dihkname": "Michelmann, Sieghart",
    "dihkrechte": "Versicherungsvertreter mit Erlaubnis nach § 34d Abs. 1 GewO",
    "kopie": "1",
    "kopiewas": "3",
    "kopiepost": "0",
    "provmail": "1",
    "kopieadresse": "S-Michelmann@web.de",
    "provmailadresse": "S-Michelmann@web.de",
    "noautoupdate": "",
    "maklerverbund": "0",
    "maklerverbundsonstige": "",
    "ktobic": "GENODEF1P06",
    "ktoiban": "DE90500909006650738600",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "0",
    "ktoinhaberanrede": "1"
  },
  {
    "id": "",
    "anrede": "",
    "titel": "",
    "vorname": "",
    "nachname": "",
    "staat": "",
    "geburt": "",
    "firma": "ABACUS GmbH",
    "rechtsform": "",
    "gruendungsjahr": "",
    "taetigkeit": "Sonst",
    "loginname": "L01007",
    "email": "s.schindler@abacus-versicherungsmakler.de",
    "tel": "0 60 42/96 17 0",
    "fax": "0 60 42/96 17 21",
    "mobile": "",
    "strasse": "An der Saline 31",
    "plz": "63654",
    "ort": "Büdingen",
    "postfach": "1169",
    "pplz": "63641",
    "ktobank": "Sparkasse Oberhessen, Friedberg (Hessen)",
    "ktoblz": "51850079",
    "ktonr": "0121002426",
    "ktoinhaber": "",
    "sendpolice": "POST",
    "sendmahnung": "NEIN",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "10.09.2013",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01007",
    "verifiziert": "1",
    "organisation": "",
    "creationdate": "10.09.2013",
    "delvmnr": "2012-09-03-02-10-01",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "",
    "dihkname": "",
    "dihkrechte": "",
    "kopie": "0",
    "kopiewas": "0",
    "kopiepost": "0",
    "provmail": "0",
    "kopieadresse": "",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "HELADEF1FRI",
    "ktoiban": "DE11518500790121002426",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "",
    "ktoinhaberanrede": ""
  },
  {
    "id": "",
    "anrede": "0",
    "titel": "",
    "vorname": "Selma",
    "nachname": "Baylav",
    "staat": "",
    "geburt": "",
    "firma": "WFL-Geschäftsstelle",
    "rechtsform": "",
    "gruendungsjahr": "",
    "taetigkeit": "Sonst",
    "loginname": "L01008",
    "email": "",
    "tel": "0 23 63/3 54 12",
    "fax": "0 23 63/3 54 14",
    "mobile": "",
    "strasse": "Castroper Straße 46",
    "plz": "45711",
    "ort": "Datteln",
    "postfach": "",
    "pplz": "",
    "ktobank": "Postbank, Dortmund",
    "ktoblz": "44010046",
    "ktonr": "0473104467",
    "ktoinhaber": "",
    "sendpolice": "POST",
    "sendmahnung": "NEIN",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "09.12.2013",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01008",
    "verifiziert": "0",
    "organisation": "",
    "creationdate": "09.12.2013",
    "delvmnr": "2012-09-03-02-10-01",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "",
    "dihkname": "",
    "dihkrechte": "",
    "kopie": "0",
    "kopiewas": "0",
    "kopiepost": "0",
    "provmail": "0",
    "kopieadresse": "",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "PBNKDEFFXXX",
    "ktoiban": "DE60440100460473104467",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "",
    "ktoinhaberanrede": "0"
  },
  {
    "id": "",
    "anrede": "",
    "titel": "",
    "vorname": "",
    "nachname": "",
    "staat": "",
    "geburt": "",
    "firma": "Werner Lohse & Heiler",
    "rechtsform": "",
    "gruendungsjahr": "",
    "taetigkeit": "Sonst",
    "loginname": "L01010",
    "email": "dh.lohse@artus-gruppe.com",
    "tel": "07 11/7 80 64 - 0",
    "fax": "07 11/7 80 64 64",
    "mobile": "",
    "strasse": "Am Wallgraben 129",
    "plz": "70565",
    "ort": "Stuttgart",
    "postfach": "800505",
    "pplz": "70505",
    "ktobank": "",
    "ktoblz": "",
    "ktonr": "",
    "ktoinhaber": "",
    "sendpolice": "EMAIL",
    "sendmahnung": "NEIN",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "09.06.2015",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01010",
    "verifiziert": "0",
    "organisation": "",
    "creationdate": "09.06.2015",
    "delvmnr": "2012-09-03-02-10-01",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "",
    "dihkname": "",
    "dihkrechte": "",
    "kopie": "1",
    "kopiewas": "1",
    "kopiepost": "1",
    "provmail": "0",
    "kopieadresse": "",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "",
    "ktoiban": "",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "0",
    "ktoinhaberanrede": ""
  },
  {
    "id": "",
    "anrede": "",
    "titel": "",
    "vorname": "",
    "nachname": "",
    "staat": "",
    "geburt": "",
    "firma": "K + A Finanzdienstleistungen GmbH",
    "rechtsform": "",
    "gruendungsjahr": "",
    "taetigkeit": "Sonst",
    "loginname": "L01013",
    "email": "info@kafinanz.de",
    "tel": "07 21/56 28 80",
    "fax": "07 21/56 36 00",
    "mobile": "",
    "strasse": "Amalie-Baader-Str. 4",
    "plz": "76137",
    "ort": "Karlsruhe",
    "postfach": "",
    "pplz": "",
    "ktobank": "Sparkasse Karlsruhe Ettlingen, Karlsruhe, Baden",
    "ktoblz": "66050101",
    "ktonr": "0015050552",
    "ktoinhaber": "",
    "sendpolice": "POST",
    "sendmahnung": "NEIN",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "27.02.2014",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01013",
    "verifiziert": "1",
    "organisation": "",
    "creationdate": "27.02.2014",
    "delvmnr": "2012-09-03-02-10-01",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "",
    "dihkname": "",
    "dihkrechte": "",
    "kopie": "1",
    "kopiewas": "1",
    "kopiepost": "1",
    "provmail": "0",
    "kopieadresse": "",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "KARSDE66XXX",
    "ktoiban": "DE13660501010015050552",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "",
    "ktoinhaberanrede": ""
  },
  {
    "id": "",
    "anrede": "1",
    "titel": "",
    "vorname": "Jürgen",
    "nachname": "Ingenkamp",
    "staat": "deutsch",
    "geburt": "22.07.1949",
    "firma": "DVV-INGENKAMP, Versicherungsmakler",
    "rechtsform": "einzel",
    "gruendungsjahr": "",
    "taetigkeit": "Sonst",
    "loginname": "L01015",
    "email": "dvv-ingenkamp@kevelaer-versicherungen.de",
    "tel": "0 28 32/4 03 44",
    "fax": "0 28 32/4 03 45",
    "mobile": "",
    "strasse": "Corneliusstraße 5",
    "plz": "47624",
    "ort": "Kevelaer",
    "postfach": "",
    "pplz": "",
    "ktobank": "Volksbank an der Niers, Kevelaer",
    "ktoblz": "32061384",
    "ktonr": "4700333014",
    "ktoinhaber": "",
    "sendpolice": "POST",
    "sendmahnung": "NEIN",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "10.09.2013",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01015",
    "verifiziert": "1",
    "organisation": "",
    "creationdate": "10.09.2013",
    "delvmnr": "2012-09-03-02-10-01",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "",
    "dihkname": "",
    "dihkrechte": "",
    "kopie": "1",
    "kopiewas": "3",
    "kopiepost": "1",
    "provmail": "0",
    "kopieadresse": "",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "GENODED1GDL",
    "ktoiban": "DE67320613844700333014",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "",
    "ktoinhaberanrede": "1"
  },
  {
    "id": "",
    "anrede": "",
    "titel": "",
    "vorname": "",
    "nachname": "",
    "staat": "",
    "geburt": "",
    "firma": "Märkischer Vers. Service GmbH",
    "rechtsform": "",
    "gruendungsjahr": "",
    "taetigkeit": "Sonst",
    "loginname": "L01017",
    "email": "",
    "tel": "03 35/68 35 40",
    "fax": "",
    "mobile": "",
    "strasse": "Bergstraße 168",
    "plz": "15230",
    "ort": "Frankfurt / Oder",
    "postfach": "",
    "pplz": "",
    "ktobank": "UniCredit Bank - HypoVereinsbank, Frankfurt (Oder)",
    "ktoblz": "17020086",
    "ktonr": "5150104175",
    "ktoinhaber": "",
    "sendpolice": "POST",
    "sendmahnung": "NEIN",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "06.03.2014",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01017",
    "verifiziert": "1",
    "organisation": "",
    "creationdate": "06.03.2014",
    "delvmnr": "2014-03-06-11-28-04",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "",
    "dihkname": "",
    "dihkrechte": "",
    "kopie": "1",
    "kopiewas": "3",
    "kopiepost": "1",
    "provmail": "0",
    "kopieadresse": "",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "HYVEDEMM471",
    "ktoiban": "DE69170200865150104175",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "",
    "ktoinhaberanrede": ""
  },
  {
    "id": "",
    "anrede": "1",
    "titel": "",
    "vorname": "Bernd",
    "nachname": "Heigel",
    "staat": "D",
    "geburt": "01.09.1953",
    "firma": "Vogel & Heigel Versicherungsmakler GmbH",
    "rechtsform": "GmbH",
    "gruendungsjahr": "",
    "taetigkeit": "Sonst",
    "loginname": "L01018",
    "email": "vogel.heigel@t-online.de",
    "tel": "03 91/60 42 13",
    "fax": "03 91/60 42 14",
    "mobile": "",
    "strasse": "Schleinufer 14",
    "plz": "39104",
    "ort": "Magdeburg",
    "postfach": "",
    "pplz": "",
    "ktobank": "Stadtsparkasse Magdeburg, Magdeburg",
    "ktoblz": "81053272",
    "ktonr": "0035371219",
    "ktoinhaber": "",
    "sendpolice": "POST",
    "sendmahnung": "NEIN",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "01.03.2016",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01018",
    "verifiziert": "1",
    "organisation": "",
    "creationdate": "01.03.2016",
    "delvmnr": "2012-09-03-02-10-01",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "",
    "dihkname": "",
    "dihkrechte": "",
    "kopie": "1",
    "kopiewas": "3",
    "kopiepost": "1",
    "provmail": "0",
    "kopieadresse": "",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "NOLADE21MDG",
    "ktoiban": "DE30810532720035371219",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "0",
    "ktoinhaberanrede": "1"
  },
  {
    "id": "",
    "anrede": "",
    "titel": "",
    "vorname": "",
    "nachname": "",
    "staat": "",
    "geburt": "",
    "firma": "Examina Finanzmanagement GmbH",
    "rechtsform": "",
    "gruendungsjahr": "",
    "taetigkeit": "Sonst",
    "loginname": "L01021",
    "email": "versicherungen@examina.de",
    "tel": "02 21/93 46 66 - 33",
    "fax": "02 21/93 46 66 - 46",
    "mobile": "",
    "strasse": "Waidmarkt 11",
    "plz": "50767",
    "ort": "Köln",
    "postfach": "",
    "pplz": "",
    "ktobank": "Sparkasse KölnBonn, Köln",
    "ktoblz": "37050198",
    "ktonr": "1932268715",
    "ktoinhaber": "",
    "sendpolice": "POST",
    "sendmahnung": "NEIN",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "04.11.2015",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01021",
    "verifiziert": "1",
    "organisation": "",
    "creationdate": "04.11.2015",
    "delvmnr": "2012-09-03-02-10-01",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "",
    "dihkname": "",
    "dihkrechte": "",
    "kopie": "1",
    "kopiewas": "3",
    "kopiepost": "0",
    "provmail": "1",
    "kopieadresse": "versicherungen@examina.de",
    "provmailadresse": "versicherungen@examina.de",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "COLSDE33XXX",
    "ktoiban": "DE66370501981932268715",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "0",
    "ktoinhaberanrede": ""
  },
  {
    "id": "",
    "anrede": "1",
    "titel": "",
    "vorname": "Meinhard",
    "nachname": "Lerke",
    "staat": "",
    "geburt": "",
    "firma": "",
    "rechtsform": "",
    "gruendungsjahr": "",
    "taetigkeit": "Sonst",
    "loginname": "L01023",
    "email": "MLerke@t-online.de",
    "tel": "05 81/55 65",
    "fax": "05 81/38 967",
    "mobile": "",
    "strasse": "Wiesenstraße 62",
    "plz": "29525",
    "ort": "Uelzen",
    "postfach": "",
    "pplz": "",
    "ktobank": "Volksbank Uelzen-Salzwedel, Uelzen, Lüneburger Hei",
    "ktoblz": "25862292",
    "ktonr": "0709055200",
    "ktoinhaber": "",
    "sendpolice": "POST",
    "sendmahnung": "NEIN",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "11.03.2014",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01023",
    "verifiziert": "0",
    "organisation": "",
    "creationdate": "11.03.2014",
    "delvmnr": "2014-03-11-01-28-00",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "",
    "dihkname": "",
    "dihkrechte": "",
    "kopie": "0",
    "kopiewas": "0",
    "kopiepost": "0",
    "provmail": "0",
    "kopieadresse": "",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "GENODEF1EUB",
    "ktoiban": "DE78258622920709055200",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "",
    "ktoinhaberanrede": "1"
  },
  {
    "id": "",
    "anrede": "0",
    "titel": "",
    "vorname": "Heike",
    "nachname": "Bocan",
    "staat": "",
    "geburt": "",
    "firma": "- Versicherungen -",
    "rechtsform": "",
    "gruendungsjahr": "",
    "taetigkeit": "Sonst",
    "loginname": "L01026",
    "email": "",
    "tel": "09 21/8 41 14",
    "fax": "09 21/8 41 14",
    "mobile": "",
    "strasse": "Meistersinger-Straße 15",
    "plz": "95444",
    "ort": "Bayreuth",
    "postfach": "",
    "pplz": "",
    "ktobank": "Volksbank-Raiffeisenbank Bayreuth, Bayreuth",
    "ktoblz": "77390000",
    "ktonr": "0005132444",
    "ktoinhaber": "",
    "sendpolice": "POST",
    "sendmahnung": "NEIN",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "10.09.2013",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01026",
    "verifiziert": "0",
    "organisation": "",
    "creationdate": "10.09.2013",
    "delvmnr": "2012-09-03-02-10-01",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "",
    "dihkname": "",
    "dihkrechte": "",
    "kopie": "0",
    "kopiewas": "0",
    "kopiepost": "0",
    "provmail": "0",
    "kopieadresse": "",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "GENODEF1BT1",
    "ktoiban": "DE72773900000005132444",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "",
    "ktoinhaberanrede": "0"
  },
  {
    "id": "",
    "anrede": "1",
    "titel": "",
    "vorname": "Horst",
    "nachname": "Zerl",
    "staat": "Deutsch",
    "geburt": "",
    "firma": "- Versicherungen -",
    "rechtsform": "Makler",
    "gruendungsjahr": "",
    "taetigkeit": "GEWO34DA1",
    "loginname": "L01029",
    "email": "info@finanzberatung-zerl.de",
    "tel": "0 91 32/91 71",
    "fax": "0 91 32/6 36 92",
    "mobile": "017664842799",
    "strasse": "Adalbert-Stifter-Str. 35",
    "plz": "91074",
    "ort": "Herzogenaurach",
    "postfach": "",
    "pplz": "",
    "ktobank": "VR-Bank Uffenheim-Neustadt, Neustadt a.d.Aisch",
    "ktoblz": "76069559",
    "ktonr": "0109400060",
    "ktoinhaber": "",
    "sendpolice": "POST",
    "sendmahnung": "NEIN",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "10.09.2013",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01029",
    "verifiziert": "1",
    "organisation": "",
    "creationdate": "10.09.2013",
    "delvmnr": "2012-09-03-02-10-01",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "D-YG5C-QT226-65",
    "dihkname": "Zerl, Horst",
    "dihkrechte": "Versicherungsmakler mit Erlaubnis nach § 34d Abs. 1 GewO",
    "kopie": "1",
    "kopiewas": "1",
    "kopiepost": "0",
    "provmail": "0",
    "kopieadresse": "info@finanzberatung-zerl.de",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "GENODEF1NEA",
    "ktoiban": "DE29760695590109400060",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "",
    "ktoinhaberanrede": "1"
  },
  {
    "id": "",
    "anrede": "1",
    "titel": "",
    "vorname": "Jan",
    "nachname": "Verheugen",
    "staat": "deutsch",
    "geburt": "",
    "firma": "Versicherungsbüro Verheugen",
    "rechtsform": "Einzelpersonengesell",
    "gruendungsjahr": "1986",
    "taetigkeit": "GEWO34DA1",
    "loginname": "L01032",
    "email": "jverheugen@aol.com",
    "tel": "02 21/39 25 03",
    "fax": "02 21/39 35 84",
    "mobile": "0172-2500968",
    "strasse": "Barbarastraße 27",
    "plz": "50996",
    "ort": "Köln",
    "postfach": "50 19 25",
    "pplz": "50979",
    "ktobank": "Brühler Bank, Brühl, Rheinl",
    "ktoblz": "37069991",
    "ktonr": "0700803023",
    "ktoinhaber": "",
    "sendpolice": "POST",
    "sendmahnung": "NEIN",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "10.09.2013",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01032",
    "verifiziert": "1",
    "organisation": "",
    "creationdate": "10.09.2013",
    "delvmnr": "2012-09-03-02-10-01",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "D-6OUY-WBLOE-09",
    "dihkname": "Verheugen, Jan",
    "dihkrechte": "Versicherungsvertreter mit Erlaubnis nach § 34d Abs. 1 GewO",
    "kopie": "1",
    "kopiewas": "3",
    "kopiepost": "1",
    "provmail": "0",
    "kopieadresse": "",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "GENODED1BRL",
    "ktoiban": "DE61370699910700803023",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "",
    "ktoinhaberanrede": "1"
  },
  {
    "id": "",
    "anrede": "1",
    "titel": "",
    "vorname": "Werner",
    "nachname": "Hammerschmidt",
    "staat": "",
    "geburt": "10.10.1984",
    "firma": "Hammerschmidt & Co. Versicherungsmakler GmbH",
    "rechtsform": "",
    "gruendungsjahr": "",
    "taetigkeit": "Sonst",
    "loginname": "L01034",
    "email": "w.a.hammerschmidt@hammerschmidt-GmbH.de",
    "tel": "0 89/8 54 90 21",
    "fax": "0 89/8 54 90 24",
    "mobile": "",
    "strasse": "Camerloher Str. 40",
    "plz": "85737",
    "ort": "Ismaning",
    "postfach": "",
    "pplz": "",
    "ktobank": "Kreissparkasse München Starnberg Ebersberg, Münche",
    "ktoblz": "70250150",
    "ktonr": "0010041721",
    "ktoinhaber": "",
    "sendpolice": "POST",
    "sendmahnung": "NEIN",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "07.12.2016",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01034",
    "verifiziert": "1",
    "organisation": "",
    "creationdate": "07.12.2016",
    "delvmnr": "2015-04-27-12-28-00",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "",
    "dihkname": "",
    "dihkrechte": "",
    "kopie": "1",
    "kopiewas": "1",
    "kopiepost": "0",
    "provmail": "0",
    "kopieadresse": "w.a.hammerschmidt@hammerschmidt-GmbH.de",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "BYLADEM1KMS",
    "ktoiban": "DE41702501500010041721",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "0",
    "ktoinhaberanrede": "1"
  },
  {
    "id": "",
    "anrede": "",
    "titel": "",
    "vorname": "",
    "nachname": "",
    "staat": "",
    "geburt": "",
    "firma": "examina Finanzdienstleistungsgesellschaft mbH",
    "rechtsform": "",
    "gruendungsjahr": "",
    "taetigkeit": "Sonst",
    "loginname": "L01035",
    "email": "info@examina-finanz.de",
    "tel": "04 61/1 50 13 - 0",
    "fax": "04 61/1 50 13 - 200",
    "mobile": "",
    "strasse": "Am Goldregen 3",
    "plz": "24944",
    "ort": "Flensburg",
    "postfach": "",
    "pplz": "",
    "ktobank": "Nord-Ostsee Sparkasse, Schleswig",
    "ktoblz": "21750000",
    "ktonr": "0017126029",
    "ktoinhaber": "",
    "sendpolice": "POST",
    "sendmahnung": "NEIN",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "01.03.2016",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01035",
    "verifiziert": "1",
    "organisation": "",
    "creationdate": "01.03.2016",
    "delvmnr": "2012-09-03-02-10-01",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "",
    "dihkname": "",
    "dihkrechte": "",
    "kopie": "1",
    "kopiewas": "1",
    "kopiepost": "1",
    "provmail": "0",
    "kopieadresse": "",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "NOLADE21NOS",
    "ktoiban": "DE50217500000017126029",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "0",
    "ktoinhaberanrede": ""
  },
  {
    "id": "",
    "anrede": "0",
    "titel": "",
    "vorname": "Silke",
    "nachname": "Sohmen",
    "staat": "",
    "geburt": "",
    "firma": "SoS-Versicherungsbüro",
    "rechtsform": "",
    "gruendungsjahr": "",
    "taetigkeit": "93HGB",
    "loginname": "L01036",
    "email": "SoS-Versicherungsbuero@web.de",
    "tel": "0 84 66/7 90",
    "fax": "08466 - 8367",
    "mobile": "",
    "strasse": "Steinbergweg 6",
    "plz": "85110",
    "ort": "Kipfenberg",
    "postfach": "",
    "pplz": "",
    "ktobank": "Sparkasse Eichstätt, Eichstätt, Bay",
    "ktoblz": "72151340",
    "ktonr": "0021018866",
    "ktoinhaber": "",
    "sendpolice": "POST",
    "sendmahnung": "NEIN",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "10.09.2013",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01036",
    "verifiziert": "0",
    "organisation": "",
    "creationdate": "10.09.2013",
    "delvmnr": "2012-09-03-02-10-01",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "",
    "dihkname": "",
    "dihkrechte": "",
    "kopie": "1",
    "kopiewas": "3",
    "kopiepost": "1",
    "provmail": "0",
    "kopieadresse": "",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "BYLADEM1EIS",
    "ktoiban": "DE82721513400021018866",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "",
    "ktoinhaberanrede": "0"
  },
  {
    "id": "",
    "anrede": "1",
    "titel": "",
    "vorname": "Herbert-Erich",
    "nachname": "Zühlsdorf",
    "staat": "Deutsch",
    "geburt": "",
    "firma": "Maklerbüro Hardt",
    "rechtsform": "Einzelfirma",
    "gruendungsjahr": "1993",
    "taetigkeit": "GEWO34DA1",
    "loginname": "L01037",
    "email": "h.e.zuehlsdorf@t-online.de",
    "tel": "0 74 22/2 34 72",
    "fax": "0 74 22/2 33 65",
    "mobile": "017667938526",
    "strasse": "Schramberger Straße 14",
    "plz": "78739",
    "ort": "Hardt",
    "postfach": "8",
    "pplz": "78739",
    "ktobank": "Postbank, Berlin",
    "ktoblz": "10010010",
    "ktonr": "0545029114",
    "ktoinhaber": "",
    "sendpolice": "POST",
    "sendmahnung": "NEIN",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "10.02.2016",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01037",
    "verifiziert": "1",
    "organisation": "",
    "creationdate": "10.02.2016",
    "delvmnr": "2015-02-20-02-28-00",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "D-PYXU-SC5EX-75",
    "dihkname": "Zühlsdorf, Herbert-Erich",
    "dihkrechte": "Versicherungsmakler mit Erlaubnis nach § 34d Abs. 1 GewO",
    "kopie": "1",
    "kopiewas": "3",
    "kopiepost": "1",
    "provmail": "0",
    "kopieadresse": "",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "0",
    "maklerverbundsonstige": "",
    "ktobic": "PBNKDEFFXXX",
    "ktoiban": "DE80100100100545029114",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "0",
    "ktoinhaberanrede": "1"
  },
  {
    "id": "",
    "anrede": "",
    "titel": "",
    "vorname": "",
    "nachname": "",
    "staat": "",
    "geburt": "",
    "firma": "P & S Versicherungsbüro",
    "rechtsform": "",
    "gruendungsjahr": "",
    "taetigkeit": "Sonst",
    "loginname": "L01038",
    "email": "",
    "tel": "0 99 74/2 19",
    "fax": "0 99 74/71 57",
    "mobile": "",
    "strasse": "Ritterstraße 10",
    "plz": "93455",
    "ort": "Traitsching",
    "postfach": "",
    "pplz": "",
    "ktobank": "Raiffeisenbank Cham-Roding-Furth im Wald, Cham, Oberpf",
    "ktoblz": "74261024",
    "ktonr": "0000040720",
    "ktoinhaber": "",
    "sendpolice": "POST",
    "sendmahnung": "NEIN",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "10.09.2013",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01038",
    "verifiziert": "0",
    "organisation": "",
    "creationdate": "10.09.2013",
    "delvmnr": "2015-11-06-06-28-00",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "",
    "dihkname": "",
    "dihkrechte": "",
    "kopie": "0",
    "kopiewas": "0",
    "kopiepost": "0",
    "provmail": "0",
    "kopieadresse": "",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "GENODEF1CHA",
    "ktoiban": "DE76742610240000040720",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "",
    "ktoinhaberanrede": ""
  },
  {
    "id": "",
    "anrede": "",
    "titel": "",
    "vorname": "",
    "nachname": "",
    "staat": "",
    "geburt": "",
    "firma": "Becker & Dettmann",
    "rechtsform": "",
    "gruendungsjahr": "",
    "taetigkeit": "Sonst",
    "loginname": "L01046",
    "email": "",
    "tel": "0 45 04/7 87 67",
    "fax": "",
    "mobile": "",
    "strasse": "Lindenstraße 69",
    "plz": "23611",
    "ort": "Bad Schwartau",
    "postfach": "",
    "pplz": "",
    "ktobank": "ING-DiBa, Frankfurt am Main",
    "ktoblz": "50010517",
    "ktonr": "0484427330",
    "ktoinhaber": "",
    "sendpolice": "EMAIL",
    "sendmahnung": "NEIN",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "10.09.2013",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01046",
    "verifiziert": "0",
    "organisation": "",
    "creationdate": "10.09.2013",
    "delvmnr": "2012-09-03-02-10-01",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "",
    "dihkname": "",
    "dihkrechte": "",
    "kopie": "1",
    "kopiewas": "3",
    "kopiepost": "0",
    "provmail": "1",
    "kopieadresse": "Michael@dettmann-versicherungen.de",
    "provmailadresse": "Michael@dettmann-versicherungen.de",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "INGDDEFFXXX",
    "ktoiban": "DE26500105170484427330",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "",
    "ktoinhaberanrede": ""
  },
  {
    "id": "",
    "anrede": "0",
    "titel": "",
    "vorname": "Andrea",
    "nachname": "Uhlemann",
    "staat": "",
    "geburt": "",
    "firma": "Vers. Service Falkensee",
    "rechtsform": "",
    "gruendungsjahr": "",
    "taetigkeit": "Sonst",
    "loginname": "L01047",
    "email": "",
    "tel": "0 33 22/20 20 22",
    "fax": "0 33 22/20 20 22",
    "mobile": "",
    "strasse": "Coburger Straße 21",
    "plz": "14612",
    "ort": "Falkensee",
    "postfach": "100111",
    "pplz": "14601",
    "ktobank": "Berliner Volksbank, Berlin",
    "ktoblz": "10090000",
    "ktonr": "1618006014",
    "ktoinhaber": "",
    "sendpolice": "POST",
    "sendmahnung": "NEIN",
    "beruf": "2017-05-12-08-28-00",
    "taetigkeit_txt": "",
    "savedate": "10.09.2013",
    "sendergaenz": "",
    "sendrechnung": "",
    "vmnr": "01047",
    "verifiziert": "0",
    "organisation": "",
    "creationdate": "10.09.2013",
    "delvmnr": "2012-09-03-02-10-01",
    "delnachname": "",
    "delloginname": "",
    "delkennwort": "",
    "delemail": "",
    "tarifsatz": "0",
    "maklertyp": "02",
    "poolvmnr": "",
    "dihk": "",
    "dihkname": "",
    "dihkrechte": "",
    "kopie": "0",
    "kopiewas": "0",
    "kopiepost": "0",
    "provmail": "0",
    "kopieadresse": "",
    "provmailadresse": "",
    "noautoupdate": "",
    "maklerverbund": "",
    "maklerverbundsonstige": "",
    "ktobic": "BEVODEBBXXX",
    "ktoiban": "DE97100900001618006014",
    "ktoinhabergeburt": "",
    "ktoinhabernachname": "",
    "ktoinhaberort": "",
    "ktoinhaberplz": "",
    "ktoinhaberstrasse": "",
    "ktoinhabertitel": "",
    "ktoinhabervorname": "",
    "ktoinhaberanderer": "",
    "ktoinhaberanrede": "0"
  }
];

